<template>
  <SeoPage page-key="designSitiWebLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'DesignSitiWebLuganoPage'
})
</script>

